import React, { useEffect, useState } from 'react';
import { LAUNCH_WINDOW_SECONDS } from '../data/sushiContent';
type CountdownTimerProps = {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function CountdownTimer({
  label,
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(LAUNCH_WINDOW_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(s => s > 0 ? s - 1 : 0), 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: pad(Math.floor(remaining / 3600)),
    unit: 'hrs'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    unit: 'min'
  }, {
    value: pad(remaining % 60),
    unit: 'seg'
  }];
  const digit = size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl';
  return <div className={className} data-id="element-61" data-mp="2zrnnvtme0she">
      <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-62" data-mp="2zsqfy4vg50yw">
        {label}
      </p>
      <div className="mt-2 flex items-start justify-center gap-3 sm:gap-4" role="timer" aria-live="off" data-id="element-63" data-mp="1bz3swlw1zsq8">
        {units.map(({
        value,
        unit
      }, i) => <React.Fragment key={unit} data-id="element-64" data-mp="123ka916i2qjf" data-mpi={i}>
            {i > 0 && <span className={`font-display font-semibold leading-none text-charcoal-500 ${digit}`} aria-hidden="true" data-id="element-65" data-mp="171c2jwb24eo5">
                :
              </span>}
            <span className="text-center" data-id="element-66" data-mp="1zqiyqon1gs68">
              <span className={`block font-display font-semibold leading-none text-ivory-50 ${digit}`} data-id="element-67" data-mp="1zphlqemgpvlv">
                {value}
              </span>
              <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.2em] text-muted" data-id="element-68" data-mp="1pz52qquaqahu">
                {unit}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}